export const contactUrls = {
    EN: '/contact/',
    FR: '/fr/nous-contacter/',
    PL: '/pl/kontakt/',
    DE: '/de/kontakt/'
}

export const favouritesUrl = {
    EN: '/favourites/', 
    FR: '/fr/mes-favoris/',
    PL: '/pl/moje-ulubione/',
    DE: '/de/meine-favoriten/'
}

export const collectionUrl = {
    EN: '/collection/',
    FR: '/fr/collection/',
    PL: '/pl/kolekcja/',
    DE: '/de/kollektion/'
}

export const materialUrl = {
    EN: '/material/',
    FR: '/fr/materiaux/',
    PL: '/pl/material/',
    DE: '/de/materialien/'
}

export const searchUrl = {
    EN: '/search/',
    FR: '/fr/rechercher/',
    PL: '/pl/wyszukiwarka/',
    DE: '/de/suche/'
}

export const whereToBuyUrl = {
    EN: '/where-to-buy/', 
    FR: '/fr/trouver-un-point-de-vente/',
    PL: '/pl/salony-sprzedazy/',
    DE: '/de/wo-kaufen/'
}

export const homepageUrl = {
    EN: '/', 
    FR: '/fr/',
    PL: '/pl/',
    DE: '/de/'
}

export const exhibitionsUrl = {
    EN: '/exhibitions/', 
    FR: '/fr/des-expositions/',
    PL: '/pl/spotkaj-nas/',
    DE: '/de/ausstellungen/'
}